export const initialState = {
    currentTime: new Date(),
};

export function time(state = initialState, action) {
    if(action.type === "SET_CURRENT_TIME") {
        let newState = {...state};
        newState.currentTime = new Date();
        return newState;
    } else {
        return state;
    }
}
